import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { HardDrive, Film } from 'lucide-react';

let opener = null;
// Ouvre le pop-up « Drive ou Frame ? » → Promise<{ delivery, delivery_link } | null>
export const askDelivery = (task) => new Promise((resolve) => (opener ? opener(task, resolve) : resolve(null)));

// Vidéo projet passée en Finie / À valider / À poster par un non-admin → demande Drive ou Frame. null = annulé.
export async function stageDeliveryExtra(task, stage, isAdmin) {
  const isVideo = task.kind === 'video' || !!task.video_format;
  if (isAdmin || !isVideo || !task.project_id || !['review', 'done', 'to_post'].includes(stage) || task.stage === stage) return {};
  const d = await askDelivery(task);
  return d ? { ...d, stage: 'review' } : null;
}

export const deliveryToast = (d) => d && d.delivery && (d.delivery === 'drive'
  ? 'Envoyée en « À valider » · Drive ✓ Le superviseur choisit le jour de post.'
  : 'Envoyée en « À valider » · Frame ✓ Le superviseur fait les retours.');

export const DELIVERY_STYLE = {
  drive: { color: '#34D399', bg: 'rgba(52,211,153,0.14)', label: 'Drive · prête à poster' },
  frame: { color: '#A78BFA', bg: 'rgba(167,139,250,0.16)', label: 'Frame · en vérification' },
};

export const DeliveryBadge = ({ delivery, id }) => {
  const st = DELIVERY_STYLE[delivery];
  if (!st) return null;
  return <span data-testid={`delivery-badge-${id}`} style={{ padding: '1px 7px', borderRadius: 999, background: st.bg, border: `1px solid ${st.color}66`, color: st.color, fontFamily: 'Sora', fontWeight: 800, fontSize: 9.5 }}>{delivery === 'drive' ? '☁︎ ' : '🎞 '}{st.label}</span>;
};

export const DeliveryDialogHost = () => {
  const [state, setState] = useState(null);
  const [kind, setKind] = useState(null);
  const [link, setLink] = useState('');
  useEffect(() => {
    opener = (task, resolve) => { setKind(null); setLink(''); setState({ task, resolve }); };
    return () => { opener = null; };
  }, []);
  if (!state) return null;
  const close = (val) => { state.resolve(val); setState(null); };
  const opt = (k, Icon, title, sub) => {
    const st = DELIVERY_STYLE[k];
    const on = kind === k;
    return (
      <button type="button" data-testid={`delivery-choice-${k}`} onClick={() => setKind(k)} style={{ flex: 1, padding: '14px 12px', borderRadius: 14, cursor: 'pointer', textAlign: 'left', background: on ? st.bg : 'rgba(255,255,255,0.03)', border: `1.5px solid ${on ? st.color : 'rgba(255,255,255,0.1)'}`, color: '#EDF1FB', transition: 'background-color 0.15s, border-color 0.15s' }}>
        <Icon size={20} color={st.color} />
        <div style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 14, marginTop: 6 }}>{title}</div>
        <div style={{ fontFamily: 'Lexend', fontSize: 11.5, color: '#A5AFC7', marginTop: 2, lineHeight: 1.4 }}>{sub}</div>
      </button>
    );
  };
  return createPortal(
    <div data-testid="delivery-dialog" onClick={() => close(null)} style={{ position: 'fixed', inset: 0, zIndex: 10001, background: 'rgba(3,6,18,0.72)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 440, background: 'linear-gradient(180deg, #1a2242 0%, #101632 100%)', border: '1px solid rgba(91,190,252,0.25)', borderRadius: 20, padding: 22, color: '#EDF1FB', boxShadow: '0 24px 60px rgba(0,0,0,0.55)' }}>
        <div style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 17 }}>Vidéo finie 🎉 Elle est où ?</div>
        <div style={{ fontFamily: 'Lexend', fontSize: 12.5, color: '#A5AFC7', margin: '4px 0 14px' }}>{state.task?.title}</div>
        <div style={{ display: 'flex', gap: 10 }}>
          {opt('drive', HardDrive, 'Sur un Drive', 'Prête : le superviseur choisit le jour de post.')}
          {opt('frame', Film, 'Sur Frame', 'En vérification : le superviseur fait les retours.')}
        </div>
        {kind && (
          <input data-testid="delivery-link-input" value={link} onChange={(e) => setLink(e.target.value)} placeholder={kind === 'drive' ? 'Lien Drive de la vidéo (conseillé)' : 'Lien Frame.io (conseillé)'}
            style={{ marginTop: 12, width: '100%', padding: '10px 12px', borderRadius: 10, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', color: '#EDF1FB', fontFamily: 'Lexend', fontSize: 13, boxSizing: 'border-box' }} />
        )}
        <button data-testid="delivery-confirm" disabled={!kind} onClick={() => { close({ delivery: kind, delivery_link: link.trim() || null }); }}
          style={{ marginTop: 14, width: '100%', padding: '12px 0', borderRadius: 10, border: 'none', cursor: kind ? 'pointer' : 'not-allowed', opacity: kind ? 1 : 0.4, background: 'linear-gradient(135deg, #5BBEFC 0%, #3E7BFA 100%)', color: '#0B1330', fontFamily: 'Sora', fontWeight: 800, fontSize: 13 }}>
          Envoyer en « À valider »
        </button>
        <button data-testid="delivery-cancel" onClick={() => close(null)} style={{ marginTop: 8, width: '100%', padding: '10px 0', borderRadius: 10, background: 'transparent', border: '1px solid rgba(255,255,255,0.12)', color: '#A5AFC7', fontFamily: 'Sora', fontWeight: 700, fontSize: 12.5, cursor: 'pointer' }}>Annuler</button>
      </div>
    </div>,
    document.body,
  );
};
